var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30.12 30.12" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "status1"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_information" },
        React.createElement(
          "g",
          { id: "text_info" },
          React.createElement(
            "g",
            { id: "score_30day" },
            React.createElement(
              "g",
              { id: "score_disable" },
              React.createElement(
                "g",
                { id: "score_x_32" },
                React.createElement("path", { id: "item_xL1", className: styles["cls-1"] || "cls-1", d: "M29.06 29.06l-28-28" }),
                React.createElement("path", { id: "item_xL2", className: styles["cls-1"] || "cls-1", d: "M29.06 1.06l-28 28" })
              )
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/iconStroke/images/status1.svg
// module id = 1645
// module chunks = 0